import React, { useEffect, useState } from 'react';
import '../privacy-choices/PrivacyChoices.css';
import Header from '../../Components/Header';
import Footer from '../../Components/Footer';
import GoogleAnalytics from '../../Components/Helpers/GoogleAnalytics';
import Fade from 'react-reveal/Fade';
import LoadingPage from '../../Components/LoadingPage';

export default function Privacy() {
    GoogleAnalytics('/privacy-policy', {});

    const windowWidth = window.innerWidth;
    const [isPageLoaded, setIsPageLoaded] = useState(false);

    useEffect(() => {
        function handlePageLoad() {
            if (document.readyState === "complete") {
                setIsPageLoaded(true);
                document.body.classList.remove('page-is-loading');
            }
        }

        document.body.classList.add('page-is-loading');

        handlePageLoad();
        document.addEventListener("readystatechange", handlePageLoad);

        return () => {
            document.removeEventListener("readystatechange", handlePageLoad);
            document.body.classList.remove('page-is-loading');
        };
    }, []);

    const _renderLoadingPage = () => {
        if (!isPageLoaded) return <LoadingPage />
    };

    return (
        <div className='terms-privacy-main'>
            {_renderLoadingPage()}
            <Header pageName='Privacy policy - Arvel Help Center' windowWidth={windowWidth} />
            <Fade>
                <div className='display-flex terms-privacy-container'>
                    <h1 className='os-header'>Privacy Policy</h1>
                    <p className='os-header-footer'>Last updated: March 14, 2025</p>

                    <p className='os-response'>Arvel Inc. built the Arvel platform as
                        a Free platform. This SERVICE is provided by
                        Arvel at no cost and is intended for use as
                        is.</p>
                    <p className='os-response'>
                        This page is used to inform visitors regarding our
                        policies with the collection, use, and disclosure of Personal
                        Information if anyone decided to use our Platform.
                    </p>
                    <p className='os-response'>
                        If you choose to use our Platform, then you agree to
                        the collection and use of information in relation to this
                        policy. The Personal Information that we collect is
                        used for providing and improving the Platform. We will not use or share your
                        information with anyone except as described in this Privacy Policy.
                    </p>
                    <p className='os-response'>
                        The terms used in this Privacy Policy have the same meanings
                        as in our Terms and Conditions, which is accessible at
                        Arvel unless otherwise defined in this Privacy Policy.
                    </p>
                    <h3 className='os-question'>Information Collection and Use</h3>
                    <p className='os-response'>
                        For a better experience, while using our Platform, we
                        may require you to provide us with certain personally
                        identifiable information. The information that
                        we request will be retained by us and used as described in this privacy policy.
                    </p>
                    <h3 className='os-question'>Log Data</h3>
                    <p className='os-response'>
                        We want to inform you that whenever you
                        use our Platform, in a case of an error in the platform
                        we collect data and information (through third party
                        products) on your phone called Log Data. This Log Data may
                        include information such as your device Internet Protocol
                        (“IP”) address, device name, operating system version, the
                        configuration of the platform when utilizing our Service,
                        the time and date of your use of the Service, and other
                        statistics.
                    </p>
                    <h3 className='os-question'>Cookies</h3>
                    <p className='os-response'>
                        Cookies are files with a small amount of data that are
                        commonly used as anonymous unique identifiers. These are sent
                        to your browser from the websites that you visit and are
                        stored on your device's internal memory.
                    </p>
                    <p className='os-response'>
                        This Service does not use these “cookies” explicitly. However,
                        the platform may use third party code and libraries that use
                        “cookies” to collect information and improve their services.
                        You have the option to either accept or refuse these cookies
                        and know when a cookie is being sent to your device. If you
                        choose to refuse our cookies, you may not be able to use some
                        portions of this Platform.
                    </p>
                    <h3 className='os-question'>Service Providers</h3>
                    <p className='os-response'>
                        We may employ third-party companies and
                        individuals due to the following reasons:
                    </p>
                    <ul className='os-response-ul'>
                        <li className='os-response-li'>To facilitate our Service;</li>
                        <li className='os-response-li'>To provide the Service on our behalf;</li>
                        <li className='os-response-li'>To perform Service-related services; or</li>
                        <li className='os-response-li'>To assist us in analyzing how our Service is used.</li>
                    </ul>
                    <p className='os-response'>
                        We want to inform users of this Service
                        that these third parties have access to your Personal
                        Information. The reason is to perform the tasks assigned to
                        them on our behalf. However, they are obligated not to
                        disclose or use the information for any other purpose.
                    </p>
                    <h3 className='os-question'>Security</h3>
                    <p className='os-response'>
                        We value your trust in providing us your
                        Personal Information, thus we are striving to use commercially
                        acceptable means of protecting it. But remember that no method
                        of transmission over the internet, or method of electronic
                        storage is 100% secure and reliable, and we cannot
                        guarantee its absolute security.
                    </p>
                    <h3 className='os-question'>Links to Other Sites</h3>
                    <p className='os-response'>
                        This Service may contain links to other sites. If you click on
                        a third-party link, you will be directed to that site. Note
                        that these external sites are not operated by us.
                        Therefore, we highly advise you to review the
                        Privacy Policy of these websites. We have
                        no control over and assume no responsibility for the content,
                        privacy policies, or practices of any third-party sites or
                        services.
                    </p>
                    <h3 className='os-question'>Children’s Privacy</h3>
                    <p className='os-response'>
                        These Services do not address anyone under the age of 13.
                        We do not knowingly collect personally
                        identifiable information from children under 13. In the case
                        we discover that a child under 13 has provided
                        us with personal information, we immediately
                        delete this from our servers. If you are a parent or guardian
                        and you are aware that your child has provided us with
                        personal information, please contact us so that
                        we will be able to do necessary actions.
                    </p>
                    <h3 className='os-question'>Changes to This Privacy Policy</h3>
                    <p className='os-response'>
                        We may update our Privacy Policy from
                        time to time. Thus, you are advised to review this page
                        periodically for any changes. We will
                        notify you of any changes by posting the new Privacy Policy on
                        this page.
                    </p>
                    <p className='os-response'>This policy is effective as of 2025-01-08.</p>
                    <h3 className='os-question'>Contact Us</h3>
                    <p className='os-response'>
                        If you have any questions or suggestions about our
                        Privacy Policy, do not hesitate to contact us at <a style={{ color: 'rgb(63, 163, 240)' }} href="mailto:info@arvel.app">info@arvel.app</a>.
                    </p>
                </div>
            </Fade>
            <Footer windowWidth={windowWidth} />
        </div>
    );
}